const FeedbackModal = () => {
  return (
    <div
      className="modal fade"
      id="feedback-modal"
      tabIndex="-1"
      aria-labelledby="feedbackModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div
            className="modal-header bg-cloud py-3"
            style={{ borderBottom: "1px solid #DDE3EE" }}
          >
            <h5
              className="modal-title fw-semi-bold"
              id="share-modalLabel"
            >
              Feedback
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">Thank you for sharing your feedback!</div>
          <div
            className="modal-footer py-3"
            style={{ borderTop: "1px solid #DDE3EE" }}
          >
            <a
              href="#"
              data-bs-dismiss="modal"
              className="link-basic"
            >
              Close
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
